export default __webpack_public_path__ + "static/media/Group1729.c98d7e05.svg";